import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-token-popup',
  templateUrl: './token-popup.component.html',
  styleUrls: ['./token-popup.component.scss']
})
export class TokenPopupComponent implements OnInit, OnDestroy {

  @Output() stayLoggedIn = new EventEmitter<void>();
  @Output() autoLogout = new EventEmitter<void>();

  countdown = 30;
  interval: any;

  ngOnInit() {
    this.startCountdown();
  }

  startCountdown() {
    this.interval = setInterval(() => {
      this.countdown--;

      if (this.countdown === 0) {
        clearInterval(this.interval);
        this.autoLogout.emit();   
      }
    }, 1000);
  }

  onStayLoggedIn() {
    clearInterval(this.interval);
    this.stayLoggedIn.emit();    
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
